<div class="badge_profile_cont">
	<ng-container *ngFor="let badgeProfile of dataBadgeProfile.badgeProfileItemList; let i = index">
		<div class="badge_profile_cont_inner">
			<a href="{{badgeProfile.link}}" target="_blank">
				<img src="{{badgeProfile.image}}" />
				<p>
					{{badgeProfile.caption}}
				</p>
			</a>
		</div>
	</ng-container>
	<!-- <div class="badge_profile_cont_inner">
		<img src="https://dummyimage.com/200x200/000/fff" />
		<p>
			Made In India
		</p>
	</div>
	<div class="badge_profile_cont_inner">
		<img src="https://dummyimage.com/200x200/000/fff" />
		<p>
			Handloom Mark
		</p>
	</div>
	<div class="badge_profile_cont_inner">
		<img src="https://dummyimage.com/200x200/000/fff" />
		<p>
			Handloom Mark
		</p>
	</div>
	<div class="badge_profile_cont_inner">
		<img src="https://dummyimage.com/200x200/000/fff" />
		<p>
			Handloom Mark
		</p>
	</div> -->
</div>
